import React from 'react'

import SimpleLogin from '../../components/auth/Simplelogin'

const simplelogins = () => {
  return (
    <>
     
     <SimpleLogin />

    </>
  )
}

export default simplelogins